// JOBE-0044.10: ScalarValuePopover — single text input for opaque-URN
// or scalar predicates. v1 surface for `inProject`, `derivedFrom`,
// `references`, `relatesTo`, `dependsOn`, `partOf`, and the
// SchemaFieldPicker's step-2 value entry.

import { useEffect, useRef, useState } from 'react';

export function ScalarValuePopover({
  initialValues = [],
  placeholder,
  onSubmit,
  onCancel,
}) {
  const [value, setValue] = useState(initialValues[0] || '');
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
    inputRef.current?.select();
  }, []);

  const submit = () => {
    const trimmed = value.trim();
    if (!trimmed) return;
    if (onSubmit) onSubmit([trimmed]);
  };

  const onKeyDown = (e) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      if (onCancel) onCancel();
    } else if (e.key === 'Enter') {
      e.preventDefault();
      submit();
    }
  };

  return (
    <div
      className="library-composer-popover library-composer-scalar"
      role="dialog"
      aria-label="Enter value"
      onKeyDown={onKeyDown}
    >
      <div className="library-composer-popover-body">
        <input
          ref={inputRef}
          type="text"
          className="library-composer-scalar-input"
          placeholder={placeholder || 'urn:jobe:…'}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          aria-label="Value"
        />
      </div>
      <div className="library-composer-popover-foot">
        <button
          type="button"
          className="library-composer-submit"
          onClick={submit}
          disabled={!value.trim()}
        >
          Add chip
        </button>
      </div>
    </div>
  );
}
